var seminars_detail =
webpackJsonp_name_([42,50],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(555);
	__webpack_require__(207);
	__webpack_require__(708);
	__webpack_require__(309);
	__webpack_require__(711);
	__webpack_require__(713);
	__webpack_require__(556);
	__webpack_require__(97);
	__webpack_require__(94);
	__webpack_require__(715);
	__webpack_require__(542);
	
	__webpack_require__(716);
	__webpack_require__(153);
	__webpack_require__(679);
	__webpack_require__(703);

/***/ }),

/***/ 94:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var slickDefaults = __webpack_require__(50);
	__webpack_require__(95);
	
	var size = __webpack_require__(56);
	
	jQuery(function () {
	    $('.js-slick-reviews').each(function () {
	        var $reviewsSlider = $(this);
	
	        $reviewsSlider.slick($.extend({}, slickDefaults.params, slickDefaults.paramsCssAnim, {
	            slidesToShow: 3,
	            adaptiveHeight: false,
	            responsive: [{
	                breakpoint: size.desktop,
	                settings: {
	                    slidesToShow: 2
	                }
	            }, {
	                breakpoint: size.tablet,
	                settings: {
	                    slidesToShow: 1
	                }
	            }]
	        }));
	    });
	});

/***/ }),

/***/ 95:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 97:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 153:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(154);
	__webpack_require__(156);
	__webpack_require__(157);

/***/ }),

/***/ 154:
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(155);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(48)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!./jquery.loader.css", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!./jquery.loader.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),

/***/ 155:
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, ".mx-loader{display:none;position:fixed;z-index:9999;width:100%;height:100%;left:0;top:0;background:hsla(0,0%,100%,.5)}.mx-loader:after{content:\"\";display:block;z-index:9999;position:absolute;margin:auto;top:0;right:0;bottom:0;left:0;background:url(" + __webpack_require__(156) + ") no-repeat 50%;width:64px;height:64px}", ""]);
	
	// exports


/***/ }),

/***/ 156:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "plugins/jquery.loader/img/jquery.loader.gif";

/***/ }),

/***/ 157:
/***/ (function(module, exports) {

	'use strict';
	
	(function ($) {
	    var mxLoader = function mxLoader(options) {
	        var self, _init;
	        var $element, $loader;
	        var defaults = {
	            speed: 200,
	            selector: 'body',
	            block: '<div class="mx-loader"></div>',
	            'class': ''
	        };
	
	        if ($.isPlainObject(options)) {
	            defaults = $.extend(true, defaults, options);
	        }
	
	        self = {
	            init: function init() {
	                if (!_init) {
	                    $element = $(defaults.selector);
	                    $loader = $(defaults.block);
	
	                    defaults = $.extend(true, defaults, options);
	                    isString(defaults['class'], true) && $loader.addClass(defaults['class']);
	
	                    _init = true;
	                }
	
	                return _init;
	            },
	
	            show: function show(speed) {
	                if (self.init()) {
	                    speed = self.speed(speed);
	                    $element.append($loader);
	                    $loader.stop(true).fadeIn(speed);
	                }
	            },
	
	            hide: function hide(speed) {
	                if (self.init()) {
	                    speed = self.speed(speed);
	                    $loader.stop(true).fadeOut(speed, function () {
	                        $loader.detach();
	                    });
	                }
	            },
	
	            speed: function speed(_speed) {
	                return $.isNumeric(_speed) ? parseInt(_speed) | 0 : defaults.speed;
	            }
	        };
	
	        return self;
	    };
	
	    /**
	     * Проверка, является ли переменная строкой
	     * Проверка на не пустаую строку
	     */
	
	    var isString = function isString(variable, noEmpty) {
	        var answer = !!(variable === '' || variable && variable.split);
	        if (noEmpty === true) {
	            answer = answer && variable.length > 0;
	        }
	
	        return answer;
	    };
	
	    window.mxLoader = new mxLoader();
	})(jQuery);

/***/ }),

/***/ 207:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 542:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 555:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(169);
	__webpack_require__(153);
	
	jQuery(function () {
	    $('.wrapper').on('click', '.pagination__btn-more', function (event) {
	        event.preventDefault();
	
	        var $this = $(this);
	        var pageCurrent = $this.data('page');
	        $this.parent().parent().remove();
	
	        window.mxLoader && window.mxLoader.show();
	
	        $.ajax({
	            type: 'GET',
	            url: '/ajax/component/maximaster:news.list/.default/',
	            data: {
	                page: pageCurrent
	            },
	            success: function success(response) {
	                window.mxLoader && window.mxLoader.hide(0);
	
	                if (response.code === 200) {
	                    var newSection = $(response.html);
	                    $('.js-grid-news:last').append(newSection[0].innerHTML);
	                    $('.js-grid-news:last').append(newSection[1].outerHTML);
	                } else {
	                    console.error(response.message);
	                }
	            },
	            dataType: 'json'
	        });
	
	        return false;
	    });
	});

/***/ }),

/***/ 556:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 679:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var styleSelects = __webpack_require__(303);
	__webpack_require__(680);
	
	$(function () {
	    styleSelects.styleSelects($('.js-styled-select'));
	    window.seminarFormMask && window.seminarFormMask();
	});
	
	/**
	 * Маска ввода для элементов, для которых сохранен data параметр
	 */
	
	window.seminarFormMask = function () {
	    if ($.fn.mask) {
	        $('.web-form input[data-mask*="9"]').each(function () {
	            var $this = $(this);
	            var mask = $this.data('mask');
	            mask && $this.mask(mask);
	        });
	    }
	};
	window.seminarEntryPage = function (seminar, date, city, seminarTime, seminarPlace, isfree) {
	    window.mxLoader = window.mxLoader || undefined;
	    window.common = window.common || undefined;
	
	    var url = '/ajax/component/maximaster:seminars.form/';
	    url += '?seminar=' + seminar + '&date=' + date + '&city=' + city + '&time=' + seminarTime + '&place=' + seminarPlace + '&isfree=' + isfree + '&template=page';
	    var time = new Date().getTime() + 400;
	
	    $.ajax({
	        url: url,
	        success: function success(result) {
	            time = time - new Date().getTime();
	            time = time > 0 ? time : 0;
	
	            var content = $('.formRegistr');
	            var contentFooter = $('.formRegistrFooter');
	
	            content.html(result.html);
	            contentFooter.html(result.html);
	
	            var $select = $('.js-styled-select', content);
	            var $selectFooter = $('.js-styled-select', contentFooter);
	            $select && styleSelects.styleSelects($select);
	            $selectFooter && styleSelects.styleSelects($selectFooter);
	
	            setTimeout(function () {
	
	                window.seminarFormMask && window.seminarFormMask();
	                window.mxLoader && window.mxLoader.hide();
	
	                content.on('click', 'input[type="submit"]', function (event) {
	                    event.preventDefault();
	
	                    var $this = $(this);
	                    var $form = content.find('form');
	
	                    $form.find('.additional-submit').remove();
	                    $form.append('<input class="additional-submit" type="hidden" name="' + this.name + '" value="' + this.value + '" />');
	
	                    time = new Date().getTime() + 400;
	                    window.mxLoader && window.mxLoader.show();
	
	                    $.ajax({
	                        url: url,
	                        data: new FormData($form.get(0)),
	                        processData: false,
	                        contentType: false,
	                        type: 'POST',
	                        success: function success(data) {
	                            time = time - new Date().getTime();
	                            time = time > 0 ? time : 0;
	
	                            setTimeout(function () {
	                                content.html(data.html);
	
	                                var $select = $('.js-styled-select', content);
	                                $select && styleSelects.styleSelects($select);
	
	                                window.seminarFormMask && window.seminarFormMask();
	                                window.mxLoader && window.mxLoader.hide();
	                            }, time);
	                        }
	                    });
	                });
	                contentFooter.on('click', 'input[type="submit"]', function (event) {
	                    event.preventDefault();
	
	                    var $this = $(this);
	                    var $form = contentFooter.find('form');
	
	                    $form.find('.additional-submit').remove();
	                    $form.append('<input class="additional-submit" type="hidden" name="' + this.name + '" value="' + this.value + '" />');
	
	                    time = new Date().getTime() + 400;
	                    window.mxLoader && window.mxLoader.show();
	
	                    $.ajax({
	                        url: url,
	                        data: new FormData($form.get(0)),
	                        processData: false,
	                        contentType: false,
	                        type: 'POST',
	                        success: function success(data) {
	                            time = time - new Date().getTime();
	                            time = time > 0 ? time : 0;
	
	                            setTimeout(function () {
	                                contentFooter.html(data.html);
	
	                                var $selectFooter = $('.js-styled-select', contentFooter);
	                                $selectFooter && styleSelects.styleSelects($selectFooter);
	
	                                window.seminarFormMask && window.seminarFormMask();
	                                window.mxLoader && window.mxLoader.hide();
	                            }, time);
	                        }
	                    });
	                });
	            }, time);
	        }
	    });
	};
	/**
	 * Всплывашка с веб формой записи на семинар
	 * @param seminar
	 * @param date
	 * @param city
	 */
	
	window.seminarEntry = function (seminar, date, city, seminarTime, seminarPlace, isfree) {
	    window.mxLoader = window.mxLoader || undefined;
	    window.common = window.common || undefined;
	
	    var url = '/ajax/component/maximaster:seminars.form/';
	    url += '?seminar=' + seminar + '&date=' + date + '&city=' + city + '&time=' + seminarTime + '&place=' + seminarPlace + '&isfree=' + isfree;
	
	    var options = {
	        classes: {
	            prompt: 'web-form-popup',
	            message: 'web-form-content'
	        }
	    };
	
	    // Ограничение по времени загрузки формы, прелоадер
	    var time = new Date().getTime() + 400;
	    window.mxLoader && window.mxLoader.show();
	    $.ajax({
	        url: url,
	        success: function success(result) {
	            time = time - new Date().getTime();
	            time = time > 0 ? time : 0;
	
	            setTimeout(function () {
	                var $modal = $.prompt(result.html, options);
	                var $content = $('.web-form-content', $modal);
	
	                window.seminarFormMask && window.seminarFormMask();
	                window.mxLoader && window.mxLoader.hide();
	
	                // Костыль связанный с тем, что в ff FormData не понимает, на какую кнопку мы нажали
	                $content.on('click', 'input[type="submit"]', function (event) {
	                    event.preventDefault();
	
	                    var $this = $(this);
	                    var $form = $this.closest('form');
	
	                    $form.find('.additional-submit').remove();
	                    $form.append('<input class="additional-submit" type="hidden" name="' + this.name + '" value="' + this.value + '" />');
	
	                    time = new Date().getTime() + 400;
	                    window.mxLoader && window.mxLoader.show();
	
	                    $('body, html').animate({ scrollTop: $content.offset().top - 15 }, 400);
	
	                    $.ajax({
	                        url: url,
	                        data: new FormData($form.get(0)),
	                        processData: false,
	                        contentType: false,
	                        type: 'POST',
	                        success: function success(data) {
	                            time = time - new Date().getTime();
	                            time = time > 0 ? time : 0;
	
	                            setTimeout(function () {
	                                $content.html(data.html);
	
	                                var $select = $('.js-styled-select', $content);
	                                $select && styleSelects.styleSelects($select);
	
	                                window.seminarFormMask && window.seminarFormMask();
	                                window.mxLoader && window.mxLoader.hide();
	                            }, time);
	                        }
	                    });
	                });
	            }, time);
	        }
	    });
	};
	
	window.seminarConsultationEntry = function (seminar, date, city, seminarTime, seminarPlace, isfree) {
	    window.mxLoader = window.mxLoader || undefined;
	    window.common = window.common || undefined;
	
	    var url = '/ajax/component/maximaster:seminars.form.consultation/';
	    url += '?seminar=' + seminar + '&date=' + date + '&city=' + city + '&time=' + seminarTime + '&place=' + seminarPlace + '&isfree=' + isfree;
	
	    var options = {
	        classes: {
	            prompt: 'web-form-popup',
	            message: 'web-form-content'
	        }
	    };
	
	    // Ограничение по времени загрузки формы, прелоадер
	    var time = new Date().getTime() + 400;
	    window.mxLoader && window.mxLoader.show();
	    $.ajax({
	        url: url,
	        success: function success(result) {
	            time = time - new Date().getTime();
	            time = time > 0 ? time : 0;
	
	            setTimeout(function () {
	                var $modal = $.prompt(result.html, options);
	                var $content = $('.web-form-content', $modal);
	
	                window.seminarFormMask && window.seminarFormMask();
	                window.mxLoader && window.mxLoader.hide();
	
	                // Костыль связанный с тем, что в ff FormData не понимает, на какую кнопку мы нажали
	                $content.on('click', 'input[type="submit"]', function (event) {
	                    event.preventDefault();
	
	                    var $this = $(this);
	                    var $form = $this.closest('form');
	
	                    $form.find('.additional-submit').remove();
	                    $form.append('<input class="additional-submit" type="hidden" name="' + this.name + '" value="' + this.value + '" />');
	
	                    time = new Date().getTime() + 400;
	                    window.mxLoader && window.mxLoader.show();
	
	                    $('body, html').animate({ scrollTop: $content.offset().top - 15 }, 400);
	
	                    $.ajax({
	                        url: url,
	                        data: new FormData($form.get(0)),
	                        processData: false,
	                        contentType: false,
	                        type: 'POST',
	                        success: function success(data) {
	                            time = time - new Date().getTime();
	                            time = time > 0 ? time : 0;
	
	                            setTimeout(function () {
	                                $content.html(data.html);
	
	                                var $select = $('.js-styled-select', $content);
	                                $select && styleSelects.styleSelects($select);
	
	                                window.seminarFormMask && window.seminarFormMask();
	                                window.mxLoader && window.mxLoader.hide();
	                            }, time);
	                        }
	                    });
	                });
	            }, time);
	        }
	    });
	};

/***/ }),

/***/ 680:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 703:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(704);
	
	$(function () {
	    /**
	     * При клике не элемент с видео получаем id элемента и делаем запрос
	     * на получение контента для всплывашки с ее последующим отображением
	     */
	
	    $(document).on('click', '.js-modal-article-video', function (event) {
	        event.preventDefault();
	
	        var $this = $(this);
	        var id = parseInt($this.data('id')) | 0;
	
	        id > 0 && window.modalArticleVideo && window.modalArticleVideo(id);
	    });
	
	    /**
	     * Пропорциональный ресайз видео проигрывателя
	     */
	
	    $(window).on('resize', function () {
	        var element = document.querySelector('.jqi--article-video');
	        if (element) {
	            var $player, player, width, originWidth, originHeight;
	            player = element.querySelector('iframe');
	
	            // Ресайз битриксового плеера происходит не корректно, убираем
	            //!player && (player = element.querySelector('div[id^="bx_flv_player"]'));
	
	            if (player) {
	                $player = $(player);
	                width = $player.width();
	                originWidth = parseInt($player.attr('width')) || parseInt(player.style.width);
	                originHeight = parseInt($player.attr('height')) || parseInt(player.style.height);
	            }
	
	            if (width && width > 0 && originWidth > 0 && originHeight > 0) {
	                var ratio = originWidth / originHeight;
	                var height = width / ratio;
	
	                $player.css({ 'max-height': height + 'px' });
	            }
	        }
	    });
	});
	
	/**
	 * Получаем через аякс контент всплывашки
	 * и показываем всплывающее окно с видео плеером
	 * @param id
	 */
	
	window.modalArticleVideo = function (id) {
	    window.mxLoader = window.mxLoader || undefined;
	
	    var url = '/ajax/component/maximaster:seminars.video/modal/?ID=' + id;
	
	    // Ограничение минимального времени загрузки формы, прелоадер
	    // Плохо выглядит, когда прелоадер очень быстро мелькает
	    var time = new Date().getTime() + 400;
	    window.mxLoader && window.mxLoader.show();
	
	    $.ajax({
	        url: url,
	        success: function success(result) {
	            // Ограничение минимального времени загрузки формы
	            time = time - new Date().getTime();
	            time = time > 0 ? time : 0;
	
	            setTimeout(function () {
	                window.mxLoader && window.mxLoader.hide(0);
	                $.prompt(result.html, {
	                    classes: {
	                        prompt: 'jqi--width-by-content jqi--article-video'
	                    }
	                });
	
	                $(window).trigger('resize');
	            }, time);
	        }
	    });
	};

/***/ }),

/***/ 704:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 708:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var slickDefaults = __webpack_require__(709);
	
	jQuery(function () {
	    $('.js-mini-slider').each(function () {
	        var $this = $(this);
	
	        $this.slick($.extend({}, slickDefaults.params, {
	            slidesToShow: 1
	        }));
	    });
	});

/***/ }),

/***/ 709:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 711:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 713:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 715:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(294);
	var form = __webpack_require__(312);
	
	jQuery(function () {
	    var addCommentFormHtml = $('.js-review-add_container').html();
	
	    var addCommentPrompt = {
	        addComment: {
	            html: addCommentFormHtml,
	            submit: function submit(e, v, m) {
	                e.preventDefault();
	                var $params = $.extend({}, form.formValidateDefaults, {
	                    rules: {
	                        review_name: { required: true },
	                        review_city: { required: true },
	                        review_rating: {},
	                        review_comment: {}
	                    },
	                    messages: {
	                        review_name: { required: 'Не указано имя' },
	                        review_city: { required: 'Не указан город' }
	                    },
	                    submitHandler: function submitHandler() {
	                        $.ajax({
	                            type: 'POST',
	                            url: '/ajax/action/reviews/add/',
	                            data: $('form.jqiform').serializeArray(),
	                            success: function success(result) {
	                                $.prompt.getState('addComment').find('.form').html('<p>' + result.html + '</p>');
	                            }
	                        });
	                        $.prompt.position();
	                    }
	                });
	                var $form = m.closest('form');
	                $form.validate($params);
	            }
	        }
	    };
	
	    $(document).on('click', '.js-jqi-add-comment', function (e) {
	        e.preventDefault();
	        $.prompt(addCommentPrompt);
	    });
	});

/***/ }),

/***/ 716:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(717);
	var slickDefaults = __webpack_require__(50);
	var styleSelects = __webpack_require__(303);
	var size = __webpack_require__(56);
	$(function () {
	    var timeItems = $('.timeItems');
	    styleSelects.styleSelects($('.js-styled-select'));
	    var $selectTime = $('.js-styled-select', timeItems);
	    $selectTime && styleSelects.styleSelects($selectTime);
	
	    var pageSeminar = $('.pageSeminar.active');
	    var pageSeminarFooter = $('.formRegistrFooter');
	    var seminarId = parseInt(pageSeminar.data('seminar')) | 0;
	    if (seminarId) {
	        window.seminarEntryPage(seminarId, pageSeminar.data('date'), pageSeminar.data('city'), pageSeminar.data('time'), pageSeminar.data('place'), pageSeminar.data('isfree'));
	    }
	
	    $('.workshop-item__date select').on('change', function (e) {
	        $('.workshop__btn a').removeClass('active');
	        $('.workshop-item__btn a').removeClass('active');
	        $('.pageSeminar').removeClass('active');
	        $('.workshop-item__prices .workshop-item__price-value').removeClass('active');
	
	        var optionSelected = $("option:selected", this);
	        var valueSelected = optionSelected.attr('data-id');
	
	        $('.workshop-item__price-value[data-id="' + valueSelected + '"]').addClass('active');
	        $('.pageSeminar[data-id="' + valueSelected + '"]').addClass('active');
	        $('.workshop__btn a[data-id="' + valueSelected + '"]').addClass('active');
	        $('.workshop-item__btn a[data-id="' + valueSelected + '"]').addClass('active');
	
	        var pageSeminarChange = $('.pageSeminar.active');
	        var seminarIdChange = parseInt(pageSeminarChange.data('seminar')) | 0;
	        window.seminarEntryPage(seminarIdChange, pageSeminarChange.data('date'), pageSeminarChange.data('city'), pageSeminarChange.data('time'), pageSeminarChange.data('place'), pageSeminarChange.data('isfree'));
	    });
	    // Обработка при клике на кнопку записи на семинар
	    $(document).on('click', '.seminar_block_name', function (event) {
	        event.preventDefault();
	        $('.block-description_detail-text ul[data-name="' + $(this).attr('data-name') + '"]').toggle();
	    });
	    $(document).on('click', '.js-seminar-entry', function (event) {
	        var $this = $(this);
	        if ($this.attr('href')) {
	            return;
	        }
	
	        event.preventDefault();
	
	        // Если не установлен адрес перехода по ссылке семинара, то отображаем форму записи на семинар
	        if (!window.seminarEntry) {
	            throw new Error('Ошибка вызова окна записи на семинар. На странице не подключен метод "seminarEntry".');
	        }
	
	        var seminar = parseInt($this.data('seminar')) | 0;
	        if (seminar) {
	            window.seminarEntry(seminar, $this.data('date'), $this.data('city'), $this.data('time'), $this.data('place'), $this.data('isfree'));
	        }
	    });
	
	    $(document).on('click', '.js-seminar-consultation-entry', function (event) {
	        var $this = $(this);
	        if ($this.attr('href')) {
	            return;
	        }
	
	        event.preventDefault();
	
	        // Если не установлен адрес перехода по ссылке семинара, то отображаем форму записи на семинар
	        if (!window.seminarConsultationEntry) {
	            throw new Error('Ошибка вызова окна записи на семинар. На странице не подключен метод "seminarEntry".');
	        }
	
	        var seminar = parseInt($this.data('seminar')) | 0;
	        if (seminar) {
	            window.seminarConsultationEntry(seminar, $this.data('date'), $this.data('city'), $this.data('time'), $this.data('place'), $this.data('isfree'));
	        }
	    });
	
	    $('.reviews__body--news').each(function () {
	        var $brandsSlider = $(this);
	
	        $brandsSlider.slick($.extend({}, slickDefaults.params, slickDefaults.paramsCssAnim, {
	            slidesToShow: 3,
	            dots: true,
	            responsive: [{
	                breakpoint: size.desktop,
	                settings: { slidesToShow: 3 }
	            }, {
	                breakpoint: size.tabletBig,
	                settings: { slidesToShow: 2 }
	            }, {
	                breakpoint: size.tablet,
	                settings: { slidesToShow: 2 }
	            }, {
	                breakpoint: size.mobileBig,
	                settings: { slidesToShow: 1 }
	            }]
	        }));
	    });
	});

/***/ }),

/***/ 717:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ })

});


// WEBPACK FOOTER //
// js/seminars_detail.2319db5711480152c770.js